<template>
  <v-card elevation="6" x_shaped v-if="ready" class="pb-1">
    <v-carousel
      eager
      v-if="properties.media && properties.media.length"
      hide-delimiters
      :show-arrows="properties.media.length > 1"
      :height="'150px'"
    >
      <v-carousel-item
        v-for="(item, i) in properties.media"
        :key="i"
        :src="item.src_thumb"
      ></v-carousel-item>
    </v-carousel>

    <center class="headingBlock pt-3 px-2">
      <div class="secondary--text text--darken-1">
        <div v-if="properties.Point_Name" class="mainHeading  ">
          <engAndTrans :value="properties.Point_Name" />
        </div>
      </div>

      <div
        translate="no"
        class="notranslate subHeading"
        v-if="
          properties.structuredData &&
            properties.structuredData.subtitle &&
            properties.structuredData.subtitle.M_ST_Address_Title &&
            properties.structuredData.subtitle.M_ST_Address_Title.value
        "
      >
        {{ properties.structuredData.subtitle.M_ST_Address_Title.value }}
      </div>
    </center>

    <PointDescriptionBody
      :functions="{ updateShowMore, openSidebarRemote }"
      type="popup"
      :Point_Description="Point_Description"
      :showMore="showMore"
    />

    <extraInfoBlocks
      :appSettings="appSettings"
      :location="properties"
      :media="properties.media"
      :Point_Name="properties.Point_Name"
      :Site_Marker_Number="properties.Site_Marker_Number"
      :structuredData="properties.structuredData"
      :functions="{ openYoutube, setSound, getAudioDetails, pointSet }"
      :isPopup="true"
    />

    <v-card-actions
      class="pb-0 mb-0 pt-0 mt-0 popupActionButtons"
      v-if="$vuetify.breakpoint.mdAndDown || !appSettings.autoOpenMoreInfo"
    >
      <v-btn
        v-if="false"
        flat
        class="moreInfoButton pb-0 mb-0 pt-0 mt-0 "
        color="menuBarColor"
        @click="openSidebar(properties.index)"
        :width="appSettings.popupButtonWidth"
      >
        More Info / Schedule
      </v-btn>

      <maptivateInfoButton
        :width="appSettings.popupButtonWidth"
        color="filterButtonColor"
        title="More Info / Schedule"
        :clickfunction="
          () => {
            openSidebar(properties.index);
          }
        "
      />

      <v-spacer></v-spacer>

      <v-btn
        v-if="false"
        right
        color="dialogActionButtonColor"
        text
        @click="clearAllPopups"
      >
        Close
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
//import { eventBus } from "../../main";
import { eventBus } from "../../main";

import Vue from "vue";

import extraInfoBlocks from "./../info/extraInfoBlocks.vue";
import engAndTrans from "./../ui/engAndTrans.vue";

import maptivateInfoButton from "../ui/maptivateInfoButton";

import PointDescriptionBody from "./../ui/PointDescriptionBody.vue";

export default Vue.extend({
  components: {
    extraInfoBlocks,
    PointDescriptionBody,
    engAndTrans,
    maptivateInfoButton
  },
  data: () => ({
    showMore: false,
    ready: false,
    showCarousel: false,
    media: []
  }),

  props: {
    //goToPointByPointName: Function,
    getAudioDetails: Function,
    openYoutube: Function,
    setSound: Function,
    openSidebar: Function,
    clearAllPopups: Function,
    appSettings: Object,
    pointSet: Object,
    properties: {
      required: true,
      type: Object
    },
    vuetifyCopy: {
      required: true,
      type: Object
    },
    browserDetectCopy: {
      required: true,
      type: Object
    }
  },

  computed: {
    Point_Description() {
      return this.properties?.content?.rendered;
    },

    linkPoint() {
      var link = null;
      try {
        if (this.properties && this.properties.linkPoint) {
          link = this.properties.linkPoint;

          try {
            link = JSON.parse(link);
          } catch (error) {
            //do nothing;
          }
        }
      } catch (error) {
        //do nothing;
      }
      return link;
    }
  },
  mounted() {
    this.$vuetify = this.vuetifyCopy;
    if (this.browserDetectCopy) {
      this.$browserDetect = this.browserDetectCopy;
    }

    this.ready = true;
    this.showCarousel = true;

    setTimeout(() => {
      if (
        !this.$vuetify.breakpoint.mdAndDown &&
        this.appSettings.autoOpenMoreInfo
      ) {
        //not small!!!
        this.openSidebar(this.properties.index);
      }
    }, 500);
  },

  methods: {
    openSidebarRemote(alsoShowMore) {
      this.openSidebar(this.properties.index);

      if (alsoShowMore) {
        eventBus.$emit("pointDiscription_expand");
      }
    },

    updateShowMore(value) {
      this.showMore = value ? value : false;
    }
  }
});
</script>

<style>
.moreInfoButton {
}

.mapboxgl-popup-anchor-bottom {
  margin-bottom: 30px;
}

.mapboxgl-popup-content {
  box-shadow: none;
}
.galPopup,
.galPopup .mapboxgl-popup-content {
  background: transparent;
  padding: 0;
}

.galPopup {
  height: 270px;
}
.galPopup .mapboxgl-popup-content .v-card {
  min-height: 90px;
  width: 240px;
  width: 295px;
  max-width: 95vw;
}

.titleBox {
  xmargin-top: -6px;
  xmargin-bottom: -6px;
}

@media only screen and (max-width: 650px) {
  .galPopup .mapboxgl-popup-content {
    zoom: 75%;
  }

  .titleBox {
    margin-top: -12px;
    margin-bottom: -12px;
  }
  .audioBox {
    margin-bottom: -6px;
  }

  .isApple .moreInfoButton {
    font-size: 0.7rem;
  }
}

.v-application .popupActionButtons button {
  margin: 0 !important;
}
</style>
